import React from 'react';
import { useHistory } from 'react-router-dom';
import { compose } from '../../utils/compose';
import { withAuthorization, withEmailVerification } from '../Session';
import * as ROUTES from '../../constants/routes';
import BrandKit from '../../modules/brandingMarketing/BrandKit';

const condition = (authUser) => !!authUser;

const toolbarButtonStyle = {
  padding: '0.65rem 1rem',
  border: '1px solid #0a0a0a',
  background: '#ffffff',
  color: '#0a0a0a',
  fontSize: '0.85rem',
  fontWeight: 600,
  letterSpacing: '0.03em',
  cursor: 'pointer',
};

const FranchiseBrandKitPageBase = () => {
  const history = useHistory();

  const handleGoHome = () => {
    history.push(ROUTES.FRANCHISE_DASHBOARD);
  };

  const handleClose = () => {
    if (typeof window !== 'undefined') {
      window.close();
      window.setTimeout(() => {
        history.push(`${ROUTES.FRANCHISE_DASHBOARD}/branding-marketing/brand-kit`);
      }, 120);
      return;
    }
    history.push(`${ROUTES.FRANCHISE_DASHBOARD}/branding-marketing/brand-kit`);
  };

  return (
    <div style={{ height: '100vh', background: '#ffffff', display: 'flex', flexDirection: 'column' }}>
      <div
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 30,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '0.75rem',
          padding: '0.85rem 1rem',
          borderBottom: '1px solid rgba(10,10,10,0.16)',
          background: '#ffffff',
        }}
      >
        <button type="button" style={toolbarButtonStyle} onClick={handleGoHome}>
          Go to Home
        </button>
        <button type="button" style={toolbarButtonStyle} onClick={handleClose}>
          Close
        </button>
      </div>
      <div style={{ flex: 1, minHeight: 0 }}>
        <BrandKit showOpenInNewPageButton={false} fullBleed />
      </div>
    </div>
  );
};

export default compose(
  withEmailVerification,
  withAuthorization(condition),
)(FranchiseBrandKitPageBase);
